module.exports = __webpack_public_path__ + "img/DMR.22fc6f14.jpg";